import { ObjectValues } from 'types';

// Where a member came from when they entered the Data Room. Four of these five
// sources funnel through the same `data-rooms/:id/auth/login` call with an
// identical URL, so the backend cannot tell them apart - the frontend tags the
// DR link with `drSource` and passes the value on at login.
export const DATA_ROOM_LOGIN_SOURCE = {
  PORTFOLIO: 'portfolio',
  SECURE_LINK: 'secure_link',
  NOTIFICATION: 'notification',
  EMAIL: 'email',
  DIRECT: 'direct',
} as const;

export type DataRoomLoginSource = ObjectValues<typeof DATA_ROOM_LOGIN_SOURCE>;

export const DR_LOGIN_SOURCE_PARAM = 'drSource';

// Carries the secure link id so the backend can resolve its name for the report
// row - a member may have access through more than one link.
export const DR_LOGIN_SOURCE_ID_PARAM = 'drSourceId';

const LOGIN_SOURCES = Object.values(DATA_ROOM_LOGIN_SOURCE) as string[];

export const isDataRoomLoginSource = (
  value?: string,
): value is DataRoomLoginSource => !!value && LOGIN_SOURCES.includes(value);
